<template>
  <div class="contrl" v-if="hidePage">
    <el-button class="searchBtn" type="primary" @click="OpenOperationRecords">操作记录</el-button>

    <el-dialog title="操作记录" :visible.sync="OperationRecordsVisible" width="50%" center custom-class="OperationRecords">
      <el-form>
        <div class="midden flex ml10">
          <el-form-item label="开始时间" style="width:35%" class="flex1">
            <el-date-picker v-model="ruleForm.startTime" type="datetime" placeholder="选择开始日期时间" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" style="width:35%" class="flex1">
            <el-date-picker v-model="ruleForm.endTime" type="datetime" placeholder="选择结束日期时间" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'23:59:59'">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态" style="width:30%" class="flex1">
            <el-select v-model="StastusValue" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="statusBtn">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button type="info" @click="rest">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
      <template>
        <el-table :data="searchForm" border style="width: 100%" height="330" class="showTable">
          <el-table-column type="index" label="序号" align="center" width="50"> </el-table-column>
          <el-table-column prop="deviceName" label="设备名称" align="center"> </el-table-column>
          <el-table-column prop="deviceNo" label="设备编号" align="center" width="130"> </el-table-column>
          <el-table-column prop="createBy" label="操作账号" align="center" width="100"> </el-table-column>
          <el-table-column prop="createTime" label="操作时间" align="center" width="140"> </el-table-column>
          <el-table-column prop="workState" label="操作时工作状态" align="center" width="120">
            <template slot-scope="scope">
              {{ scope.row.workState == 1 ? '工作' : '测试' }}
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作详情" align="center" width="100">
            <template slot-scope="scope">
              {{ scope.row.state == 1 ? '打开水泵' : '关闭水泵' }}
            </template>
          </el-table-column>
          <el-table-column prop="endPressure" label="操作作时末端压力" align="center" width="160">
            <template>
              <el-button type="text" @click="ViewingEnd">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <span slot="footer" class="dialog-footer">
        <el-pagination
          class="pagination"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="query.pageNum"
          @size-change="getsearchForm"
          @current-change="getsearchForm"
          :page-sizes="[10, 20]"
          :page-size.sync="query.pageSize"
          :total="total"
        >
        </el-pagination>
      </span>
      <el-dialog width="40%" title="详情" :visible.sync="EndPressureBox" append-to-body custom-class="EndPressureBox" :modal="true" center>
        <template v-if="!SprayData.length">
          <div class="center f16 blod">暂无数据</div>
        </template>
        <template v-else>
          <el-table :data="getValues" border style="width: 100%;" :show-header="false" class="table">
            <el-table-column class="supplement" v-for="(item, index) in getHeaders" :key="index" :prop="item" align="center" :fixed="index < 1 ? true : false"> </el-table-column>
          </el-table>
        </template>
      </el-dialog>
    </el-dialog>
    <div class="f-list flex1 flex contrl">
      <div class="controlFire ml20 mt20" v-for="(it, idx) in list" :key="idx">
        <div class="firstControl flex">
          <div class="leftImg">
            <div class="mt10 f16 blod waterPumpTitle" :title="it.deviceName">{{ it.deviceName }}</div>
            <img src="@/assets/img/paifeng/beng.png" alt="" v-if="it.functionState == 0 || it.functionState == null" />
            <img class="" src="@/assets/img/paifeng/beng.gif" alt="" v-if="it.functionState == 1 || !it.functionState == null" />
          </div>
          <div class="rightImg ">
            <div>
              <p class="f16 blod">电源状态</p>
              <!-- 主电源 -->
              <div class="flex mt10  center" :class="[it.mainPowerSupply == null || it.mainPowerSupply == 0 ? 'eleButon' : ' eleButonLine']">
                <span>电源1</span>
                <div class="flex">
                  <i :class="[it.mainPowerSupply == null || it.mainPowerSupply == 0 ? 'closeState' : 'workState', 'closeState ml10']"></i>
                  <span class="flex ml5"> {{ it.mainPowerSupply == null || it.mainPowerSupply == 0 ? '关' : '正常 ✔' }}</span>
                </div>
              </div>
              <!-- 负电源 -->
              <div class="flex mt10  center" :class="[it.auxiliaryPowerSupply == null || it.auxiliaryPowerSupply == 0 ? 'eleButon' : ' eleButonLine']">
                <span> 电源2</span>
                <div class="flex">
                  <i :class="[it.auxiliaryPowerSupply == null || it.auxiliaryPowerSupply == 0 ? ' closeState' : 'workState', 'closeState ml10']"></i>
                  <span class="flex ml5"> {{ it.auxiliaryPowerSupply == null || it.auxiliaryPowerSupply == 0 ? '关' : '正常 ✔' }}</span>
                </div>
              </div>
            </div>
            <div class="mt20">
              <p class="f16 blod">水泵状态</p>
              <div class="flex">
                <i :class="[it.functionState == null ? 'closeState' : it.functionState == 0 ? 'closeState' : 'workState']"></i><span class="flex ml5"> 运行</span>
                <i :class="[it.functionState == null ? 'closeState' : it.functionState == 0 ? 'stopState' : 'closeState']" class="ml10"></i> <span class="ml5"> 停止</span>
              </div>
            </div>
            <div class="mt20">
              <p class="f16 blod">工作模式</p>
              <div class="flex">
                <i :class="[it.workModeType == null ? 'stopState' : it.workModeType == 0 ? 'workState' : 'closeState', 'closeState']"></i>
                <span class="flex ml5"> 自动</span>
                <i :class="[it.workModeType == null ? 'stopState' : it.workModeType == 1 ? 'workState' : 'closeState', 'closeState', 'ml10']"> </i>
                <span class="ml5"> 手动</span>
              </div>
            </div>
          </div>
        </div>
        <div class="secondControl">
          <div class="leftContent">
            <p class="f16 blod">远程控制开关</p>
            <!-- ding -->
            <div style="margin-top: 5px; height:15px"></div>
            <div class="btnCont mt10 ">
              <div :class="[it.functionState == 1 ? ' disabledOpen' : null, 'buttonCont buttonOpen']" @click="open(idx)" v-hasPermi="['device:waterPump:start']">启动</div>
              <div
                :class="[it.functionState == null || it.functionState == 0 ? 'disabledOpen' : null, 'buttonCont buttonClose']"
                @click="close(it, idx, 0, it.deviceName)"
                v-hasPermi="['device:waterPump:stop']"
              >
                停止
              </div>
            </div>
            <!-- 开启弹框 -->
            <el-dialog title="" :visible.sync="ConfirmOperation" width="45%" center custom-class="openForm">
              <span slot="title" class="f16 blod " style="color: #c62631;">远程操作前请确认</span><br />
              <div>
                <span class="f16 blod center">管网压力是否下降？</span><br />
                <div>
                  <span class="blod">当前的喷淋末端压力为：</span><br /><br />
                  <template v-if="!SprayData.length">
                    <div class="center f16 blod">暂无数据</div>
                  </template>
                  <el-table :data="getValues" border style="width: 100%;" :show-header="false" class="table" :show-overflow-tooltip="true" v-else>
                    <el-table-column
                      class="supplement"
                      v-for="(item, index) in getHeaders"
                      :key="index"
                      :prop="item"
                      align="center"
                      :fixed="index < 1 ? true : false"
                    ></el-table-column>
                  </el-table>
                  <br />
                  <span class="center">
                    <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                      <el-form-item label="验证码：" prop="code" :rules="[{ required: true, message: ' ', trigger: 'blur' }]">
                        <el-input v-model="ruleForm.code" placeholder="请输入验证码" clearable @clear="getImg"></el-input>
                      </el-form-item>
                    </el-form>
                    <img :src="changeImg" style="margin-left: 15px;" class="imgchange cursor" @click="getImg" />
                  </span>
                  <span class="center red prompt mb50">请谨慎操作，以免引起损失！</span>
                </div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="ConfirmOperation = false">取 消</el-button>
                <el-button type="primary" @click="sureOpen('ruleForm', idx)">确 定</el-button>
              </span>
            </el-dialog>
          </div>
          <div class="rightContent">
            <p class="f16 blod">状态控制开关</p>

            <div class="btnCont mt10 status center">
              <div class="cursor" :class="{ eleButonSelect: it.workState == item.val }" v-for="(item, index) in Status_switch" :key="index" @click="switchStatus(item, idx)">
                {{ item.label }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/utils/config.js';
if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsWaterPumpUrl;
} else if (process.env.NODE_ENV == 'production') {
  //线上 or 测试
  var wsUrl = config.wsWaterPumpUrl;
}
import { changeImg } from '@/api/home';
import { waterPumpList, waterSystemPressureNew, OperationRecordsList } from '@/api/facility.js';
export default {
  name: 'tab5',
  props: ['cpNum'],
  data() {
    return {
      outerVisible: false,
      innerVisible: false,
      list: [],
      hidePage: true,
      activeVar: 0, // 工作测试选择下标
      Status_switch: [
        { label: '工作', val: 1 },
        { label: '测试', val: 0 },
      ],
      ConfirmOperation: false, // 开启操作
      OperationRecordsVisible: false, // 操作记录
      EndPressureBox: false, // 末端压力详情的弹框状态
      SprayData: [], // 喷淋数据
      headers: [
        // 数据表头
        { prop: 'deviceName', label: '位置' },
        { prop: 'pressure', label: '压力' },
      ],
      changeImg: [], //  图片验证码
      ruleForm: {
        code: '', // 验证码
        checkId: '', // 图片验证码需要的checkId
        startTime: '', // 开始时间
        endTime: '', // 结束时间
        remark: null, // 开关接口 1:开 0:关
        deviceType: null, // 	设备类型
        deviceNo: '', // 设备编号
        workState: '', // 工作状态 1：工作 0：测试
      },
      workingCondition: [], // 工作状态 *Array*
      searchForm: [], // 搜索内容
      options: [
        // 状态选则
        { value: 0, label: '测试' },
        { value: 1, label: '工作' },
      ],
      StastusValue: '', // 操作记录 状态选择
      query: {
        pageSize: 10, // 条数
        pageNum: 1, // 页数
      },
      total: 0, //  总页
      websock: null, // 实时推送
      nowDeviceMessage: '', // 消息
    };
  },
  // 表格处理
  computed: {
    getHeaders() {
      return this.SprayData.reduce((pre, cur, index) => pre.concat(`value${index}`), ['title']);
    },
    getValues() {
      return this.headers.map((item) => {
        return this.SprayData.reduce((pre, cur, index) => Object.assign(pre, { ['value' + index]: cur[item.prop] }), { title: item.label });
      });
    },
  },
  created() {},
  mounted() {
    if (this.cpNum) {
      this.getwaterSystemPressureNew();
      // this.getsearchForm();
      this.getList();
    }
    var me = this;
    var lockReconnect = false; //避免重复连接
    createWebSocket(); // 创建websocket
    function createWebSocket() {
      try {
        me.ws = new WebSocket(wsUrl);
        websocketInit();
      } catch (e) {
        log('catch');
        websocketReconnect(wsUrl);
      }
    }
    function websocketInit() {
      // 建立 web socket 连接成功触发事件
      me.ws.onopen = function(evt) {
        onOpen(evt);
      };
      // 断开 web socket 连接成功触发事件
      me.ws.onclose = function(evt) {
        websocketReconnect(wsUrl);
        onClose(evt);
      };
      // 接收服务端数据时触发事件
      me.ws.onmessage = function(evt) {
        onMessage(evt);
      };
      // 通信发生错误时触发
      me.ws.onerror = function(evt) {
        websocketReconnect(wsUrl);
        onError(evt);
      };
    }
    function onOpen(evt) {
      log('建立设备链接');
      //心跳检测重置
      if (!me.heartCheck.isStart) {
        me.heartCheck.start();
      }
    }
    function onClose(evt) {}
    function onMessage(evt) {
      // console.log(evt)
      if (evt.data === '"shoudao"') {
      } else {
        //！！这里接受消息 写东西
        var data = JSON.parse(evt.data);
        setTimeout(() => {
          me.nowDeviceMessage = data;
        }, 1000);
      }
      //拿到任何消息都说明当前连接是正常的
      me.heartCheck.start();
    }
    function websocketReconnect(url) {
      if (lockReconnect) {
        // 是否已经执行重连
        return;
      }
      lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      tt && clearTimeout(tt);
      var tt = setTimeout(function() {
        createWebSocket(url);
        lockReconnect = false;
      }, 5000);
    }
    //心跳检测
    me.heartCheck = {
      timeout: 5000,
      timeoutObj: null,
      serverTimeoutObj: null,
      isStart: false,
      start: function() {
        var self = this;
        this.isStart = true;
        this.timeoutObj && clearTimeout(this.timeoutObj);
        this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
        this.timeoutObj = setTimeout(function() {
          //发送测试信息，后端收到后，返回一个消息，
          me.ws.send('fasong');
          self.serverTimeoutObj = setTimeout(function() {
            me.ws.close();
          }, self.timeout);
        }, this.timeout);
      },
    };
    function onError(evt) {
      log('通信错误：' + evt.data);
    }

    const makeConnection = () => {
      this.connection = new WebSocket(wsUrl);
      // Other logic codes here
      this.connection.onclose = () => {
        this.connection = null;
      };
    };
    if (this.connection) {
      this.connection.onclose = makeConnection;
      this.connection.close();
    } else {
      makeConnection();
    }
  },

  beforeDestroy() {
    this.ws.close();
    this.ws.onclose = function() {
      console.log('设备关闭');
    };
  },
  watch: {
    cpNum() {
      this.getList();
      this.getwaterSystemPressureNew();
    },
    nowDeviceMessage(val) {
      // console.log('socket value', val);
      if (this.list && val && val.deviceType == 241) {
        if (this.list.machineNo === val.machineNo) {
          var obj = { ...this.list, ...val };
          this.list = obj;
        }
        this.getList();
      }
    },
  },

  methods: {
    // 获取图片验证码
    getImg() {
      changeImg().then((res) => {
        this.changeImg = 'data:image/gif;base64,' + res.data.img;
        this.ruleForm.checkId = res.data.checkId;
      });
    },

    // 获取列表数据
    getList() {
      waterPumpList({ companyNum: this.cpNum }).then((res) => {
        // log(res, '水泵列表');
        if (res.data) {
          this.hidePage = true;
          this.list = res.data;

          this.workingCondition = res.data.map((item) => {
            return {
              statusButton: item.workState, // 状态
            };
          });
        }

        if (!res.data.length) {
          this.hidePage = false;
          return this.$message.warning('该业务尚未开通，请联系管理员');
        }
      });
    },

    // 获取搜索列表数据
    getsearchForm() {
      var obj = {
        startTime: this.ruleForm.startTime,
        endTime: this.ruleForm.endTime,
        workState: this.StastusValue,
        companyNum: this.cpNum,
      };
      OperationRecordsList({ companyNum: this.cpNum, ...this.query, ...obj }).then((res) => {
        // log(res, '历史操作记录');
        this.searchForm = res.rows;
        this.total = res.total;
      });
    },
    // 点击操作记录 调用搜索接口
    OpenOperationRecords() {
      this.OperationRecordsVisible = true;
      this.getsearchForm();
    },
    // 工作与测试按钮 切换选择
    switchStatus(item, idx) {
      this.list[idx].workState = item.val;
      console.log(this.ruleForm.workState, 'set work state');
    },
    // 开启远程控制
    open(idx) {
      if (this.list[idx].workState == null) {
        console.log(this.list[idx].workState, 'set open work state');
        return this.$message.warning('请选择控制状态');
      } else {
        this.getImg();
        this.activeIndex = idx;
        this.ruleForm.code = ''; // 打开时 清除验证码文本框的输入内容
        this.ConfirmOperation = true; // 开启并打开dialog
      }
    },
    // 确认开启
    sureOpen(formName, item) {
      const index = this.activeIndex;
      this.$refs[formName][index].validate((valid) => {
        if (this.ruleForm.code == '') return this.$message.warning('请输入验证码');
        else {
          var obj = {
            code: this.ruleForm.code, // 验证码
            checkId: this.ruleForm.checkId, // 需要checkId
            remark: 1,
            deviceType: this.list[index].deviceType,
            deviceNo: this.list[index].deviceNo,
            workState: this.list[index].workState,
          };
          // log(this.activeIndex, "work condition");
          this.$put('/mqtt/mqttInfo/switchMQ', obj).then((res) => {
            // log(res, '确定开启操作');
            this.ConfirmOperation = false;
            this.getList();
            return this.$message.success('成功');
          });
        }
        if (valid) {
        } else {
          return this.$message.warning('请输入正确的验证码，确保操作正确');
        }
      });
    },
    // 关闭远程控制
    close(it, status, zero, name) {
      if (this.list[status].workState == null) {
        console.log(this.list[status].workState, 'get work state');
        return this.$message.warning('请选择控制状态来关闭设备');
      } else {
        var obj = {
          code: this.ruleForm.code,
          checkId: this.ruleForm.checkId,
          remark: 0,
          deviceType: this.list[status].deviceType,
          deviceNo: this.list[status].deviceNo,
          workState: this.list[status].workState,
        };
        this.$confirm(`确认要关闭${name}这个设备吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          await this.$put('/mqtt/mqttInfo/switchMQ', obj).then((res) => {
            return setTimeout(() => {
              this.getList();
            }, 500);
          });
          this.$message({
            type: 'success',
            message: '已关闭!',
          });
        });
      }
    },
    // 获取喷淋数据
    getwaterSystemPressureNew() {
      waterSystemPressureNew({ companyNum: this.cpNum }).then((res) => {
        if (res.data) this.SprayData = res.data;
      });
    },
    // 查询
    OperationRecords() {
      var obj = {};
      this.$get('mqtt/mqttOperationRecord/list', this.cpNum).then((res) => {
        this.searchForm = res.data;
      });
    },

    // 搜索查询
    search() {
      this.query.pageNum = 1;
      var keywords = {
        startTime: this.ruleForm.startTime,
        endTime: this.ruleForm.endTime,
        workState: this.StastusValue,
        companyNum: this.cpNum,
      };
      log(keywords);
      this.$get('mqtt/mqttOperationRecord/list', keywords).then((res) => {
        this.searchForm = res.rows;
        this.total = res.total;
      });
    },
    // 查看末端压力按钮方法
    ViewingEnd() {
      this.EndPressureBox = true;
      /**
       * @codeValue
       */
    },
    // 重置
    rest() {
      this.ruleForm.startTime = '';
      this.ruleForm.endTime = '';
      this.StastusValue = '';
      this.query.pageNum = 1;
      this.$get('mqtt/mqttOperationRecord/list', { companyNum: this.cpNum }).then((res) => {
        this.searchForm = res.rows;
        this.total = res.total;
      });
    },
  },
};
</script>
<style scoped lang="scss">
// 水泵标题
.waterPumpTitle {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.controlFire {
  .eleButon {
    border: 1px solid #c0c0c0;
    padding: 4px 2px;
    width: 120px;
    border-radius: 15px;
  }
  .eleButonLine {
    padding: 4px 2px;
    width: 120px;
    border-radius: 15px;
    border: 1px solid #3a94ff;
  }
  .eleButonSelect {
    background-color: #3a94ff !important;
    color: white;
    // box-shadow: 1px 1px 1px 1px #a6a6a6;
  }
  .closeState {
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .workState {
    background: #399022;
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    // background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .stopState {
    background: #d0451b;
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    // background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .leftImg {
    width: 280px;
    border: 2px solid #78b6ff;
    padding: 0 10px 10px;
  }
  .rightImg {
    width: 150px;
    border: 2px solid #78b6ff;
    border-left: none;
    padding: 10px;
  }
  .secondControl {
    width: 430px;
    display: flex;
    border: 2px solid #78b6ff;
    border-top: none;

    .btnCont {
      display: flex;
      justify-content: space-around;
      .buttonCont {
        width: 55px !important;
        cursor: pointer;
        padding-left: 3px;
        color: #fff;
        height: 60px;
        font-size: 16px;
        text-align: center;
        line-height: 3;
        letter-spacing: 2px;
      }
      .disabledOpen {
        opacity: 0.5;
        width: 50px;
        height: 50px;
        pointer-events: none;
      }
    }
    .buttonOpen {
      width: 50px !important;
      height: 50px !important;
      background: repeating-radial-gradient(circle at center, #a1f1af, #49ba29);
    }
    .buttonClose {
      width: 50px !important;
      height: 50px !important;
      background: repeating-radial-gradient(circle at center, #ffe4d6, 30%, #eb0000);
    }
    .leftContent {
      width: 60%;
      height: 160px;
      padding: 10px;
    }
    .rightContent {
      width: 36%;
      height: 160px;
      border-left: 2px solid #78b6ff;
      margin-left: 27px;
      padding: 10px;
      .cursor {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        line-height: 40px;
        text-align: center;
        margin-top: 25px;
        background-color: #c4dfff;
      }
    }
  }
}
.contrl {
  position: relative;
  margin-top: 40px;
  width: 100%;
  .searchBtn {
    position: absolute;
    right: 0;
    top: -40px;
  }
}
.pagination {
  display: flex;
  justify-content: center;
  align-content: center;
}
.imgchange {
  width: 100px;
  height: 40px;
  border: none;
  margin-top: -22px;
}
.blod {
  letter-spacing: 2px;
}
.prompt {
  // margin-bottom: 20px;
  height: 0;
}
.table {
  // padding: 0px;
  position: relative;
  .supplement {
    position: absolute;
    top: 20px;
    right: 19.5px;
    z-index: 10;
    width: 7px;
    height: 54px;
    box-sizing: border-box;
    background: #fafafa;
    border-bottom: 1px solid #dfe6ec;
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px; // 横向滚动条
    height: 8px; // 纵向滚动条 必写
  }
  // 下面的一条线 可以取消也可以不用
  ::v-deep .el-table__body-wrapper {
    overflow: auto;
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-track {
    background: white;
    border-radius: 2px;
  }
  // 问题六
  ::v-deep .el-table__fixed-right::before {
    background: #ffffff !important;
  }
  ::v-deep .el-table__fixed-right {
    right: 6px !important;
    bottom: 6px !important;
  }
}
::v-deep .openForm {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // /*height:600px;*/
  // max-height: calc(100% - 200px);
  // max-width: calc(100% - 30px);
}
::v-deep .OperationRecords {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
  // /*height:600px;*/
  // max-height: calc(100% - 200px);
  // max-width: calc(100% - 30px);
}
.statusBtn {
  margin: 40px 10px;
}
::v-deep .OperationRecords {
  margin-top: -150vh !important;
}
// 点击查看详情弹出框
::v-deep .EndPressureBox {
  position: absolute;
  top: 42%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
